import { createContext, useContext, useMemo, type ReactNode } from 'react'
import type { DataSource } from './dataSource'
import { dexieDataSource } from './dexieDataSource'
import { withUndoForget } from './withUndoForget'

// Default is Dexie: the app needs no provider, and tests that mock Dexie modules keep working.
// Durch den Wächter, damit `⌘Z` auch ohne Provider die richtige Regel fährt (ADR 0028).
const DataSourceContext = createContext<DataSource>(withUndoForget(dexieDataSource))

/**
 * Hands a data source to everything below — Storybook and tests pass
 * `createMemoryDataSource(…)`. Keep `source` stable for the lifetime of the tree.
 */
export function DataSourceProvider({ source, children }: { source: DataSource; children: ReactNode }) {
  // Einmal je Quelle: Der Wächter darf die Identität nicht bei jedem Anstrich wechseln.
  const guarded = useMemo(() => withUndoForget(source), [source])
  return <DataSourceContext.Provider value={guarded}>{children}</DataSourceContext.Provider>
}

/** The data source for this part of the tree (Dexie unless a provider says otherwise). */
export function useDataSource(): DataSource {
  return useContext(DataSourceContext)
}
